module.exports = __webpack_public_path__ + "img/ts_2025_aapex.7415ad0e.jpg";